import { Action } from '@/_core/fluxstore/types';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer } = useStorymapStore();

export class ChangePersonaFilter extends Action<StorymapState> {
    public static ACTION_TYPE = 'ChangePersonaFilter';

    public constructor(public personaId: string) {
        super(ChangePersonaFilter.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState, action: ChangePersonaFilter): void => {
    if (state.filterState.personaIds.includes(action.personaId)) {
        state.filterState.personaIds = state.filterState.personaIds.filter((x) => x !== action.personaId);
    } else {
        state.filterState.personaIds.push(action.personaId);
    }
};

//@ts-ignore
registerReducer(ChangePersonaFilter.ACTION_TYPE, reducer);
